import { TabProxy } from "encampy";

export async function automateKSTier2OnlineLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  const usernameSelector = "input[name='ctl00$ContentPlaceHolder1$loginControl$UserName']";
  const passwordSelector = "input[name='ctl00$ContentPlaceHolder1$loginControl$Password']";
  const loginButtonSelector = "button#ctl00_ContentPlaceHolder1_loginControl_LoginBtn";

  // Wait for the login page to load
  await tab.waitForElement(usernameSelector, {
    timeout: 10000,
  });

  // Type in the username
  await tab.type(usernameSelector, username);

  // Type in the password
  await tab.type(passwordSelector, password);

  // Click Login button
  await tab.click(loginButtonSelector);

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
